const messages = {
    "ACCOUNT_SUM": "Account",
    "ADD_MEMEBER_FAILED": "Add member failed. Reason: {Message}",
    "ADD_ORIGINATOR_FAILED": "Add originator failed. Reason : Originator had been added already!",
    "APPLICATION MANUAL": "APPLICATION MANUAL",
    "APP_BANNER_DESC": "Continual improvement process aims to capture ideas from personnel to include everyone to develop company´s work environment and processes. This tool is for creating and managing initiatives and continual improvement proposals.",
    "APP_NAME": "Wärtsilä Continuous Improvement Management Application",
    "ASK_EXPERT_OPINIONS": "E-mail has been sent!",
    "ATTACH_FILES_HELP": "Attach files",
    "Account": "Account",
    "Active": "Active",
    "Add": "Add",
    "Add comment or opinion": "Add comment or opinion",
    "Add new initiative type": "Add new initiative type",
    "Admin": "Admin",
    "All": "All",
    "Amount": "Amount",
    "Approve": "Approve",
    "Ask expert opinion": "Ask expert opinion",
    "Attach files": "Attach files.",
    "Attached files": "Attached files",
    "Author": "Author",
    "BROWSE": "BROWSE",
    "Browse CI-Proposals": "Browse CI-Proposals",
    "Browse Initiatives": "Browse Initiatives",
    "Browse old Initiatives and CI-Proposals": "Browse old Initiatives and CI-Proposals",
    "CI Proposal created": "CI Proposal created",
    "CI-Proposal": "CI-Proposal",
    "CIP": "improvements",
    "CIP Group": "CIP-Group",
    "CIP Id": "CIP #",
    "CIP Groups": "CIP-Groups",
    "CIP-GROUPS": "CIP-GROUPS",
    "CIP-Group": "CIP-Group",
    "CIP.CI_GROUP.HELP": "Select your own CIP-Group.",
    "CIP.NAME.HELP": "Fill in this field part of your name. And select right one. If you can not find yourself in the list contact Juha Jaakkola juha.jaakkola@wartsila.com",
    "CIP.PROPOSAL.HELP": "Describe your improvement proposal here.",
    "CIP.TITLE.HELP": "Give describing header for your improvement proposal.",
    "CIP_DESC": "Continue Improvement is local way of working development made in group. With CIP you can develop e.g. cleanliness or your own working environment, way of working, work safety and comfort issues.",
    "CIP_FULL": "CI-Proposals",
    "CONTINUOUS IMPROVEMENT": "CONTINUOUS IMPROVEMENT",
    "CREATE CONTINUOUS IMPROVEMENT": "CREATE CONTINUOUS IMPROVEMENT",
    "CREATE INITIATIVE": "CREATE INITIATIVE",
    "CURRENT_SITUATION": "Current situation",
    "CURRENT_SITUATION_HELP": "Describe how current situation looks like.",
    "Clear": "Clear",
    "Coach name": "Coach",
    "Comment": "Comment",
    "Cost center": "Cost center",
    "Created": "Created",
    "Created by": "Created by",
    "Created date": "Created date",
    "DEPOSIT_WITHDRAW_AMOUNT": "Amount to be added/removed",
    "Department": "Department",
    "Deposit": "Deposit",
    "Deposit or withdraw money": "Deposit or withdraw money for CIP group",
    "Description": "Description",
    "Display Name": "Display Name",
    "Domain": "Domain",
    "Email": "Email",
    "Email sent": "Email sent",
    "Error": "Error",
    "Euro": "Euro",
    "Euros": "Euros",
    "Expert Opinion": "Expert Opinion",
    "FOCUS Users": "FOCUS Users",
    "Failed": "Failed",
    "Filter": "Filter",
    "GOOD TO KNOW": "GOOD TO KNOW",
    "Group members": "Group members",
    "Group transactions": "Group transactions",
    "HOME": "HOME",
    "Hide reward calculator": "Hide reward calculator",
    "How to use this application": "How to use this application",
    "IMPROVEMENT_PROPOSAL": "Improvement proposal",
    "IMPROVEMENT_PROPOSAL_HELP": "Describe your improvement proposal.",
    "INITIATIVE": "INITIATIVE",
    "INITIATIVE_DESC": "Initiative is personal development proposal, which includes a solution where economic benefits for the company can be calculated.",
    "INITIATIVE_NAME": "Initiative name",
    "INITIATIVE_NAME_HELP": "Give describing header for your initiative.",
    "INITIATIVE_TYPE_HELP": "Select an initiative type",
    "Id": "Id",
    "Idea originator": "Idea originator",
    "Ideas": "Ideas",
    "In review": "In review",
    "Initiative Types": "Initiative Types",
    "Initiative created": "Initiative created",
    "Initiative reassigned to:": "Initiative reassigned to: ",
    "Initiative type with same title exists.": "Initiative type with same title exists.",
    "Initiatives": "Initiatives",
    "Is Active": "Is Active",
    "Is Admin": "Is Admin",
    "Journals": "Action log",
    "LOCAL IDEAS": "BROWSE IDEAS",
    "LOCALE_en": "ENGLISH-EN",
    "LOCALE_en-EN": "ENGLISH-EN",
    "LOCALE_en-US": "ENGLISH-EN",
    "LOCALE_fi": "SUOMI-FI",
    "LOCALE_fi-FI": "SUOMI-FI",
    "LOCALE_sv": "SVENSKA-SV",
    "LOCALE_sv-SE": "SVENSKA-SV",
    "Last 30 Days": "Last 30 Days",
    "Last 7 Days": "Last 7 Days",
    "Last Month": "Last Month",
    "MANAGE IDEAS": "MANAGE IDEAS",
    "Make decision": "Make decision",
    "Manager": "Manager",
    "Modified": "Modified",
    "NAME_HELP": "Fill in this field part of your name. And select right one. If you can not find yourself in the list contact Juha Jaakkola juha.jaakkola@wartsila.com. Fill in your information even if you will leave your idea anonymously.",
    "NEW_CI-GROUP-CREATED": "New CI-Group created :#{Id}",
    "NEW_INITIATIVE_TYPE_ADDED": "New initiative type is added",
    "NO_DATA": "No data available ...",
    "Name": "Name",
    "New": "New",
    "Next": "Next",
    "No name selected": "No name selected",
    "Not Active": "Not Active",
    "Not admin": "Not admin",
    "Open": "Open",
    "Paid": "Paid",
    "Pending": "Pending",
    "Please select a name and click": "Please select a name and click",
    "Previous": "Previous",
    "Print": "Print",
    "Proposal": "Proposal",
    "REASSIGN_OK": "Re-assign initiative successfully !",
    "REPORT_ANONYMOUS": "I want to leave my idea anonymously",
    "REWARD.EFFECTIVENESS": "Cost sawings efficiency (leadtime, turnover).",
    "REWARD.EFFECTIVENESS_COL1": "More cost efficient solution. Faster leadtime in operation. E.g. Operation development or cost saving app. 500 - 1 000 € per year.",
    "REWARD.EFFECTIVENESS_COL2": "Faster leadtime or step removal.  E.g. Development of Machining or assembly or sawings app. 1 000 - 5 000 € per year.",
    "REWARD.EFFECTIVENESS_COL3": "Shorter end product or part assembly leadtime a lot or savings 5 000 - 50 000 € per year.",
    "REWARD.EFFECTIVENESS_COL4": "Exceptionally significant savings within full life time or significant cost savings e.g. Service methods. Or sawings > 50 000 € per year.",
    "REWARD.ENVIRONMENT": "Environment",
    "REWARD.ENVIRONMENT_COL1": "Less material and energy use. / Less use of non-hazardous waste.",
    "REWARD.ENVIRONMENT_COL2": "Decrease material and energy use in departments  / Decreases amount of dangerous waste (E.g. Oil waste) /Decrease waste significantly.",
    "REWARD.ENVIRONMENT_COL3": "Significantly reduced environmental risks. Reduces significantly factory pollution.",
    "REWARD.ENVIRONMENT_COL4": "Improvement proposal, that many Wärtsilä units can benefit from by reducing emission, energy- and material use(including chemicals), or to reduce amount of waste.",
    "REWARD.GLOBAL": "Global",
    "REWARD.OWN_BUSINESS_UNIT": "Business unit",
    "REWARD.OWN_DEPARTMENT": "Own department",
    "REWARD.OWN_STATION": "Own workstation",
    "REWARD.QUALITY": "Quality",
    "REWARD.QUALITY_COL1": "Small improvment of quality in your own workstation E.g. Making unclear instructions easier to read.",
    "REWARD.QUALITY_COL2": "Improved quality in your own department E.g. Develop better ways of working, that reduces and prevents quality issues from occuring.",
    "REWARD.QUALITY_COL3": "Reduces and prevents quality issues inside business unit. / Innovation that significally improves product/process quality.",
    "REWARD.QUALITY_COL4": "Solution that reduces or prevents quality issues from occuring that has been a problem globally for a long time / Significant innovation.",
    "REWARD.SAFETY": "Work safety",
    "REWARD.SAFETY_COL1": "Small improvement of work safety at your workstation that concerns tools, ways of working or working environment.",
    "REWARD.SAFETY_COL2": "Improvement of safety that reduces chemical or any other exposure, or has significant impact on ergonomics / Improvement of safety that reduces risks of accident.",
    "REWARD.SAFETY_COL3": "Reduces and prevents occupational accidents or sick leaves from occuring at the business unit. Improves significantly work safety or occupational health.",
    "REWARD.SAFETY_COL4": "Reduces  occupational accidents or sick leaves in many Wärtsilä units / Innovation, that globally significantly improves work safety or occupational health.",
    "REWARD_CONSULTED": "I have consulted with initiative originator.",
    "REWARD_SENT": "I have sent rewarding template to SD Worx and initiative committee secretary.",
    "Ready": "Ready",
    "Reassign": "Reassign",
    "Reassign to different person": "Reassign to different person",
    "Rejected": "Rejected",
    "Remove": "Remove",
    "Request for expert opinion:": "Request for expert opinion: ",
    "Responsible person": "Responsible person",
    "Reward sum": "Reward sum",
    "Rewarded with amount:": "Rewarded with amount: ",
    "Rewarding form": "Rewarding",
    "Rewarding template": "Rewarding template",
    "Rules": "Rules",
    "SAP Number": "SAP Number",
    "SAVE_CI-GROUP-OK": "Save CI-Group successfully",
    "SAVE_CIP_OK": "Save CI-Proposal successfully !",
    "SAVE_DECISION_OK": "Decision was saved successfully !",
    "SAVE_INITIATIVE_FAILED": "Failed to save initiative !",
    "SAVE_INITIATIVE_OK": "Initiative was saved successfully !",
    "SAVE_INITIATIVE_TYPE_OK": "Initiative type is saved successfully",
    "SAVE_REWARD_OK": "Reward has been saved successfully",
    "SEARCH": "SEARCH",
    "SEE_YOU_AGAIN": "You have signed out successfully from our service. We hope to see you again.",
    "SEND_TO_COMMITTEE": "Haluan aloitteen käsiteltäväksi uudessa järjestelmässä",
    "Save": "Save",
    "Save Draft": "Save Draft",
    "Save and send": "Save and send",
    "Select": "Select",
    "Select an initiative type here": "Select an initiative type here.",
    "Show reward calculator": "Show reward calculator",
    "Sign in again": "Sign in again",
    "State": "State",
    "Status": "Status",
    "Success": "Success",
    "TASK_WARNING": "You have {value} pending tasks.",
    "INITIATIVE_WARNING": "{value} pending initiatives",
    "IDEAS_WARNING": "{value} pending CIP ideas",
    "OPINION_WARNING": "{value} pending opinion requests",
    "TRANSACTION_FAIL": "Transaction failed. Reason: {Message}",
    "TRANSACTION_OK": "Transaction is executed successfully !",
    "Thank you": "Thank you",
    "This Month": "This Month",
    "This Year": "This Year",
    "Title": "Title",
    "Title_FI": "Title FI",
    "Title_EN": "Title EN",
    "Title_SV": "Title SV",
    "To continue, please select a name and click": "To continue, please select a name and click",
    "Toggle table filter": "Show/hide filter",
    "Type": "Type",
    "USERS": "USERS",
    "USER_ALREADY_IN_GROUP": "User is already a member of the group !",
    "User": "User",
    "User with same account exists.": "User with same account exists.",
    "WELCOME": "Welcome to",
    "Waiting For Commitee": "Waiting For Commitee",
    "Waiting To Be Implemented": "Waiting To Be Implemented",
    "Withdraw": "Withdraw",
    "YEAR": "year",
    "You can browse existing CI-Proposals": "You can browse existing CI-Proposals",
    "You can browse existing Initiatives": "You can browse existing Initiatives",
    "initiative(s)": "initiatives",
    "Send emails": "Send emails",
    "Country": "Country",
    "MANUAL_URL": "https://fiidm01.wnsd.com/kronodoc/1502/GetLatest/9148861/FOCUS%202.0%20ENG%20Manual.pptx",
    "FOCUS_INDICATORS": "Focus indicators",
    "LINKS_HEADER": "LINKS"
};

export default messages;



// WEBPACK FOOTER //
// ./locales/en.js